

















import { Component, Vue } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";

@Component({
  components: {
    Modal,
  },
})
export default class MensagemErro extends Vue {
  msgErro: string | null = null;

  get tituloErro(): string {
    return "Erro";
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async exibirMensagem(msg: string) {
    const modal = this.$refs.modal as Modal;
    modal.open();
    this.msgErro = msg;
  }
}
